/**
 * Created by zhaoxu on 2018/5/9.
 */
import Vue from 'vue'
export default new Vue();
